var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manual-root-sty" },
    [
      _c(
        "el-form",
        {
          ref: "manualFormRef",
          staticClass: "form-sty",
          attrs: {
            size: "small",
            model: _vm.manualForm,
            rules: _vm.manualRules,
            "label-width": "170px",
            "label-suffix": " ："
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "姓名", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.manualDis.nameDis,
                  placeholder: "请输入姓名"
                },
                model: {
                  value: _vm.manualForm.name,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.manualForm,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "manualForm.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "证件类型", prop: "cardType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择证件类型" },
                  model: {
                    value: _vm.manualForm.cardType,
                    callback: function($$v) {
                      _vm.$set(_vm.manualForm, "cardType", $$v)
                    },
                    expression: "manualForm.cardType"
                  }
                },
                _vm._l(_vm.cardTypeList, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "证件号码", prop: "card" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.manualDis.idCardDis,
                  placeholder: "请输入证件号码"
                },
                model: {
                  value: _vm.displayIdCard,
                  callback: function($$v) {
                    _vm.displayIdCard =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "displayIdCard"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "certPhoto" } },
            [
              _c("template", { slot: "label" }, [
                _c("span", [
                  _vm._v("\n          证件照片：\n          "),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                    _vm._v("（身份信息页）")
                  ])
                ])
              ]),
              _c("div", { staticClass: "card-box" }, [
                _c(
                  "div",
                  { staticClass: "bank" },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "show-file-list": false,
                          "before-upload": function(file) {
                            return _vm.beforeIdeCareUpload(file, 1)
                          }
                        }
                      },
                      [
                        _vm.manualForm.certPhoto
                          ? _c("img", {
                              staticClass: "card-img",
                              attrs: { src: _vm.manualForm.certPhotoUrl }
                            })
                          : _c("div", [
                              _c("div", { staticClass: "card-item" }, [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon",
                                  staticStyle: {
                                    "font-size": "3vw",
                                    color: "#C2C2C2"
                                  }
                                })
                              ])
                            ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("el-alert", {
                attrs: {
                  title:
                    "建议上传：《台湾居民来往大陆通行证》《港澳居民来往内地通行证》《护照》",
                  type: "warning",
                  closable: false
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手持证件照片", prop: "handheldCertPhoto" } },
            [
              _c("div", { staticClass: "card-box" }, [
                _c(
                  "div",
                  { staticClass: "bank" },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "show-file-list": false,
                          "before-upload": function(file) {
                            return _vm.beforeIdeCareUpload(file, 2)
                          }
                        }
                      },
                      [
                        _vm.manualForm.handheldCertPhoto
                          ? _c("img", {
                              staticClass: "card-img",
                              attrs: {
                                src: _vm.manualForm.handheldCertPhotoUrl
                              }
                            })
                          : _c("div", [
                              _c("div", { staticClass: "card-item" }, [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon",
                                  staticStyle: {
                                    "font-size": "3vw",
                                    color: "#C2C2C2"
                                  }
                                })
                              ])
                            ])
                      ]
                    ),
                    _c("img", {
                      staticClass: "card-img",
                      attrs: {
                        src: "/images/auth/authIcon/cardOnHand.png",
                        alt: "示例图"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("ProtocolRead", {
            staticClass: "btns-sty",
            attrs: { Agree: _vm.agreement },
            on: {
              "update:Agree": function($event) {
                _vm.agreement = $event
              },
              "update:agree": function($event) {
                _vm.agreement = $event
              }
            }
          }),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "sub-btn-sty",
                  attrs: { type: "primary", "native-type": "submit" }
                },
                [_vm._v("提交审核")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07c7df28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c7df28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/person/components/manualReview.vue
// module id = nILA
// module chunks = 51 91